<template>
  <v-dialog v-model="isOpen" width="40rem" @click:outside="closeDialog">
    <v-card>
      <v-card-title class="headline lighten-2" primary-title>
        {{ $t('gridView.selectCompetitors.modalTitle') }}
      </v-card-title>
      <v-form lazy-validation @submit.prevent="submit">
        <v-card-text>
          <v-autocomplete
            v-model="selectedCompetitorKeys"
            multiple
            dense
            solo
            flat
            small-chips
            hide-details
            :items="competitorOptions"
            :label="$t('pricing.mainHeaders.competitors')"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn small text outlined class="cancel-btn" @click="closeDialog">
            {{ $t('actions.cancel') }}
          </v-btn>
          <v-btn small class="save" color="primary" @click="download">
            {{ $t('actions.download') }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  props: {
    isOpen: {
      required: true,
    },
  },
  data() {
    return {
      selectedCompetitorKeys: [],
    };
  },
  computed: {
    ...mapState('clientConfig', ['toggleLogic']),
    ...mapGetters('competitorMetadata', ['competitorsForExport']),
    competitorOptions() {
      return this.competitorsForExport.map(competitor => ({
        text: competitor.competitorDisplayDescription,
        value: competitor.competitorKey,
      }));
    },
  },
  created() {
    // competitors are already sorted by competitorOrder. by default, the top 3 are selected for export.
    const configCompetitors = Object.values(this.toggleLogic.competitorsToSelectOnExport || {});

    // If configuration is empty => pick the top 3
    if (!configCompetitors.length) {
      this.selectedCompetitorKeys = this.competitorOptions.slice(0, 3).map(item => item.value);
    }
    // Otherwise => filter competitor options based on config
    else {
      this.selectedCompetitorKeys = this.competitorOptions
        .filter(item =>
          configCompetitors.map(cfg => cfg.toUpperCase()).includes(item.text.toUpperCase())
        )
        .map(item => item.value);
    }
  },

  methods: {
    closeDialog() {
      this.$emit('closeSelectCompetitorDialog');
    },
    async download() {
      this.$emit('downloadData', { selectedCompetitorKeys: this.selectedCompetitorKeys });
      this.closeDialog();
    },
  },
};
</script>

<style lang="scss" scoped>
.info-text {
  font-size: 1.5rem;
}
</style>
